export function sortListByColumnAndDirection(list, column, isAscending, transformingFunction = defaultTransformingFunction) {
    const modifier = isAscending ? 1 : -1;
    return [...list].sort((first, second) => {
        let firstTransformed = toGeneralFormForSorting(first[column], transformingFunction);
        let secondTransformed = toGeneralFormForSorting(second[column], transformingFunction);
        if (firstTransformed < secondTransformed) {
            return -1 * modifier;
        }
        if (firstTransformed > secondTransformed) {
            return 1 * modifier;
        }
        return 0;
    });
}

function toGeneralFormForSorting(value, transformingFunction) {
    let result = transformingFunction(value);
    if (typeof result === "string") {
        return result.toUpperCase();
    }
    return result;
}

function defaultTransformingFunction(value) {
    return value;
}